import styles from "./Hero.module.css";
import { HeroIllustration } from "../icons/Illustrations";
import { MotifLine } from "../icons/MotifLine";
import { siteConfig } from "../../siteConfig";

export function Hero() {
  return (
    <section id="top" className={styles.hero} aria-labelledby="hero-heading">
      <MotifLine className={styles.motif} />

      <div className={`container ${styles.grid}`}>
        <div>
          <span className="eyebrow">Outdoor Advertising · Branding · Signage</span>

          <h1 id="hero-heading" className={styles.headline}>
            Make Your Brand
            <br />
            Impossible to Miss.
          </h1>

          <p className={styles.lede}>
            Outdoor advertising, branding and signage solutions that put your business where
            people see it.
          </p>

          <div className={styles.ctaRow}>
            <a href="#contact" className="btn btn-primary">
              Let&rsquo;s Talk
            </a>
            <a href="#services" className={styles.explore}>
              Explore Services ↓
            </a>
          </div>

          <span className={styles.label}>
            Outdoor Advertising • Branding • Signage | {siteConfig.location.city}, {siteConfig.location.state}
          </span>
        </div>

        <HeroIllustration
          className={styles.art}
          role="img"
          aria-label="Illustration of a roadside hoarding, shop signage, building signage and a branded vehicle in an urban street scene"
        />
      </div>
    </section>
  );
}
